/**
 * Indian mobile number helpers for OTP login (B-01A).
 */

/** Strip spaces, dashes, and any non-digit characters. */
export function normalizePhone(raw) {
  return String(raw || '').replace(/\D/g, '');
}

/** Exactly 10 digits starting with 6, 7, 8, or 9. */
export function isValidIndianMobile(phone) {
  const digits = normalizePhone(phone);
  return /^[6-9]\d{9}$/.test(digits);
}

/** Client-side validation message for blur / submit. */
export function getIndianMobileError(phone) {
  const digits = normalizePhone(phone);
  if (!digits) return '';
  if (digits.length !== 10) return 'Enter a valid 10-digit mobile number.';
  if (!/^[6-9]/.test(digits)) return 'Mobile number must start with 6, 7, 8, or 9.';
  return '';
}
